import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const bundleBuilder: ComponentTemplate = {
  id: "826448ce-98c6-43b2-b643-17ac6b9b2438",
  storeId: null,
  scope: "left-bar",
  type: "component",
  name: "Product/Bundle Builder",
  leftBarCategory: { main: "product", subCategory: "bundles" },
  preview: "basic/bulleted-list.svg",
  template: {
    id: "c44b79d5-404f-4577-938c-72b78540e788",
    name: "Bundle Builder",
    type: "bundleBuilder",
    props: {
      style: {},
      "style@md": {
        flexDirection: "column",
      },
      "style@sm": {
        flexDirection: "column",
      },
      allowMultipleOfSameItem: true,
      bundleTargets: "variants",
      bundleTargetType: "variants",
      productsWithVariants: [],
      bundleDiscountThresholds: [
        {
          discount: {
            type: "percentageOff",
            value: 10,
          },
          quantity: 3,
        },
        {
          discount: {
            type: "percentageOff",
            value: 20,
          },
          quantity: 5,
        },
      ],
    },
    children: [
      {
        id: "c49de084-44f1-4225-8df4-65a677783339",
        name: "Bundle Header (Mobile)",
        type: "bundleHeader",
        props: {
          style: {
            display: "none",
          },
          "style@md": {
            display: "block",
          },
          "style@sm": {
            display: "block",
          },
        },
        children: [
          {
            id: "e8cef917-a661-4a0c-aa86-83c6e984d549",
            type: "text",
            props: {
              text: "<h2>Build Your Bundle</h2>",
              style: {
                fontSize: "32px",
                fontWeight: 700,
                lineHeight: "39px",
              },
            },
          },
          {
            id: "0f0f2a6a-84d6-43f7-877c-58b232931862",
            name: "Description of bundle goes here",
            type: "text",
            props: {
              text: "<p>A description of the bundle offering.</p>",
              style: {
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "19px",
                marginBottom: "24px",
                letterSpacing: "-0.05em",
              },
            },
          },
          {
            id: "51f28481-ff04-4c97-b146-f8024c062f33",
            name: "Bundle Tier Selector",
            type: "bundleTierSelector",
            props: {},
            children: [],
          },
        ],
      },
      {
        id: "67d0704e-08c8-4e1f-ada2-aa22fc0475b3",
        name: "Bundle Grid",
        type: "bundleGrid",
        props: {},
        children: [
          {
            id: "07ec36b5-4bfb-45c3-b430-961bdf07f280",
            name: "Bundle Item Tile",
            type: "bundleProductTile",
            props: {
              style: {
                fontWeight: 400,
              },
            },
            children: [
              {
                id: "96cc53de-c676-404c-84e4-acc1dfeda6dd",
                name: "Variant Selectors",
                type: "bundleProductVariantSelector",
                props: {
                  style: {
                    fontWeight: 400,
                  },
                },
                children: [],
              },
              {
                id: "698bc129-d004-40b1-8b01-27c26f76303c",
                name: "Add To Bundle Button",
                type: "bundleAddToBundleButton",
                props: {
                  style: {
                    fontWeight: 400,
                  },
                },
                children: [],
              },
            ],
          },
        ],
      },
      {
        id: "1b94bbea-3ac8-4951-8c49-83ffbf85880a",
        name: "Bundle Summary (Desktop)",
        type: "bundleSummary",
        props: {
          style: {
            display: "block",
          },
          "style@md": {
            display: "none",
          },
          "style@sm": {
            display: "none",
          },
        },
        children: [
          {
            id: "033eb680-b89c-4d8b-9e6d-400913c854ef",
            type: "text",
            props: {
              text: "<h2>Build Your Bundle</h2>",
              style: {
                fontSize: "32px",
                fontWeight: 700,
                lineHeight: "39px",
              },
            },
          },
          {
            id: "3b55b9d5-623b-4f13-896b-87bed89877c2",
            name: "Description of bundle goes here",
            type: "text",
            props: {
              text: "<p>A description of the bundle offering.</p>",
              style: {
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "19px",
                marginBottom: "24px",
                letterSpacing: "-0.05em",
              },
            },
          },
          {
            id: "1866fc05-df14-4409-8951-2b94dd875167",
            name: "Bundle Tier Selector",
            type: "bundleTierSelector",
            props: {},
            children: [],
          },
          {
            id: "65b38bb6-599b-4e65-8a80-28dc64671a9a",
            name: "Bundle Items",
            type: "bundleCart",
            props: {},
            children: [],
          },
          {
            id: "d3797b46-0473-4fef-894e-ee38b9736a0b",
            name: "Bundle Progress Bar",
            type: "bundleProgressBar",
            props: {
              style: {
                fontWeight: 400,
              },
              backgroundColor: "#F00600FF",
            },
            children: [],
          },
          {
            id: "ea4f74ef-d8a5-4303-9dec-a9a97441d72a",
            name: "Bundle Cart Total",
            type: "bundleCartTotals",
            props: {
              style: {},
            },
            children: [],
          },
          {
            id: "33b1fb69-3f20-4fb1-a9cf-39f85ff6ea8b",
            name: "Add To Cart Button",
            type: "bundleAddToCartButton",
            props: {
              style: {
                color: "#FFFFFFFF",
                width: "100%",
                padding: "12px 16px",
                fontSize: "16px",
                textAlign: "center",
                fontWeight: "600",
                backgroundColor: "#000000FF",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderBottomRightRadius: "6px",
              },
            },
            children: [],
          },
        ],
      },
      {
        id: "a1ac2f79-5b07-48d2-a579-6255aec3b761",
        name: "Bundle Footer (Mobile) 1",
        type: "bundleFooter",
        props: {
          style: {
            display: "none",
          },
          children: [],
          "style@md": {
            top: "initial",
            left: "auto",
            right: "auto",
            width: "100vw",
            bottom: "0px",
            zIndex: "30",
            display: "block",
            flexGrow: "unset",
            position: "sticky",
            alignSelf: "auto",
            __transform: {
              skewX: "0deg",
              skewY: "0deg",
              scaleX: "100%",
              scaleY: "100%",
              scaleZ: "100%",
              rotateX: "0deg",
              rotateY: "0deg",
              rotateZ: "0deg",
              translateX: "0px",
              translateY: "0px",
              translateZ: "0px",
            },
          },
          "style@sm": {
            top: "initial",
            left: "auto",
            right: "auto",
            width: "100vw",
            bottom: "0px",
            zIndex: "30",
            __width: "100vw",
            display: "block",
            flexGrow: "unset",
            position: "sticky",
            alignSelf: "auto",
            __transform: {
              skewX: "0deg",
              skewY: "0deg",
              scaleX: "100%",
              scaleY: "100%",
              scaleZ: "100%",
              rotateX: "0deg",
              rotateY: "0deg",
              rotateZ: "0deg",
              translateX: "0px",
              translateY: "0px",
              translateZ: "0px",
            },
          },
        },
      },
    ],
  },
};
